/* src/app/submission-manage/submission-manage.component.css */
.block {
  display: block;
}
.small-block {
  display: block;
  margin-bottom: 5px;
}
.font90 {
  font-size: 90%;
}
.map-div {
  height: 600px;
}
.input-file {
  display: inline;
  padding: 1px;
  border: #ccc solid 1px;
}
.form-btn {
  margin-bottom: 30px;
  margin-top: 20px;
}
.grid-align-left {
  text-align: left;
}
.disabled {
  color: #d6d6d6;
}
.btn1 {
  margin-right: 10px;
}
.example-class {
  height: 400px;
}
.inputField {
  width: 350000px !important;
}
.small-text {
  font-size: 0.75rem;
}
::ng-deep .p-select {
  border: 1px solid #ced4da !important;
  border-radius: 4px;
}
::ng-deep .p-select:hover {
  border-color: #86b7fe !important;
}
::ng-deep .p-select:focus,
::ng-deep .p-select.p-focus {
  border-color: #86b7fe !important;
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);
}
::ng-deep .p-tabs,
::ng-deep .p-tabs .p-tablist,
::ng-deep .p-tabs .p-tablist-content,
::ng-deep .p-tabs .p-tablist-tabs,
::ng-deep .p-tabs .p-tablist-tab-list,
::ng-deep .p-tabs nav,
::ng-deep .p-tabs ul,
::ng-deep .p-tabs > div:first-child,
::ng-deep p-tabs,
::ng-deep p-tablist {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
  outline: none !important;
}
::ng-deep .p-tabs .p-tab {
  border: 1px solid #dee2e6 !important;
  border-radius: 4px;
  margin-right: 12px;
  margin-bottom: 8px;
  background: #f8f9fa !important;
  padding: 2px;
}
::ng-deep .p-tabs .p-tab button,
::ng-deep .p-tabs .p-tab,
::ng-deep .p-tabs .p-tab * {
  color: #0d6efd !important;
  font-weight: 500;
  font-size: 1.1rem !important;
}
::ng-deep .p-tabs .p-tab.p-active {
  border-color: #0d6efd !important;
  background: #e7f1ff !important;
}
::ng-deep .p-tabs .p-tab.p-active button,
::ng-deep .p-tabs .p-tab.p-active,
::ng-deep .p-tabs .p-tab.p-active * {
  color: #0d6efd !important;
  font-weight: 600;
}
::ng-deep .p-tabs .p-tab:hover {
  border-color: #0d6efd !important;
  background: #f8f9fa;
}
::ng-deep .p-tabs .p-tabpanels {
  border: 2px solid #dee2e6 !important;
  border-radius: 4px;
  padding: 20px;
  margin-top: 15px;
  background: white;
}
::ng-deep .p-tabs .p-tabpanel {
  border: none !important;
  padding: 0 !important;
}
::ng-deep .p-panel .p-panel-header {
  background: #f8f9fa !important;
  border: 1px solid #dee2e6 !important;
  color: #212529 !important;
  border-radius: 4px;
  padding: 12px 15px !important;
  text-align: left !important;
  font-weight: bold !important;
}
::ng-deep .p-panel .p-panel-header .p-panel-title {
  text-align: left !important;
  font-weight: bold !important;
}
::ng-deep .p-panel .p-panel-content {
  background: white !important;
  border: 1px solid #dee2e6 !important;
  border-top: none !important;
  border-radius: 0 0 4px 4px;
}
::ng-deep .p-panel {
  border: none !important;
  box-shadow: none !important;
  margin-top: 15px !important;
  margin-bottom: 15px !important;
}
::ng-deep .p-fileupload .p-fileupload-choose,
::ng-deep .p-fileupload .p-button {
  background-color: #0d6efd !important;
  border: 1px solid #0d6efd !important;
  color: white !important;
  padding: 8px 16px !important;
  border-radius: 4px !important;
  font-weight: 500 !important;
  margin-right: 8px !important;
  transition: all 0.2s ease !important;
}
::ng-deep .p-fileupload .p-fileupload-choose:hover,
::ng-deep .p-fileupload .p-button:hover {
  background-color: #0b5ed7 !important;
  border-color: #0a58ca !important;
}
::ng-deep .p-fileupload .p-fileupload-choose:disabled,
::ng-deep .p-fileupload .p-button:disabled {
  background-color: #6c757d !important;
  border-color: #6c757d !important;
  opacity: 0.65 !important;
  cursor: not-allowed !important;
}
::ng-deep .p-fileupload .p-button-icon {
  font-size: 1rem !important;
  margin-right: 4px !important;
}
::ng-deep .p-fileupload,
::ng-deep .p-fileupload *,
::ng-deep .p-fileupload-content,
::ng-deep .p-fileupload-buttonbar,
::ng-deep .p-fileupload .p-fileupload-buttonbar,
::ng-deep p-fileupload,
::ng-deep p-fileupload > div,
::ng-deep .p-fileupload > div {
  border: none !important;
  background: transparent !important;
  padding: 0 !important;
  box-shadow: none !important;
  outline: none !important;
}
::ng-deep .p-fileupload .p-fileupload-choose,
::ng-deep .p-fileupload .p-button {
  padding: 8px 16px !important;
}
.radio input[type=radio] {
  margin-right: 8px;
}
.checkbox input[type=checkbox] {
  margin-right: 8px;
}
::ng-deep .p-datepicker,
::ng-deep .p-datepicker-input-icon-container,
::ng-deep p-datepicker {
  border: none !important;
}
::ng-deep .p-datepicker input,
::ng-deep p-datepicker input {
  border: 1px solid #ced4da !important;
  border-radius: 4px;
}
::ng-deep .p-datepicker input:hover {
  border-color: #86b7fe !important;
}
::ng-deep .p-datepicker input:focus,
::ng-deep .p-datepicker input.p-focus {
  border-color: #86b7fe !important;
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);
}
::ng-deep .p-datepicker-panel,
::ng-deep .p-datepicker .p-datepicker-panel,
::ng-deep p-datepicker .p-datepicker-panel {
  background: white !important;
  border: 1px solid #ced4da !important;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15) !important;
  border-radius: 4px !important;
}
::ng-deep .p-datepicker-panel .p-datepicker-header,
::ng-deep .p-datepicker-panel .p-datepicker-calendar-container {
  background: white !important;
}
/*# sourceMappingURL=submission-manage.component.css.map */
